import { $Formutil } from 'react-bootstrap-formutil';
import { CountryItem } from 'types/common';
import { CustomerInfoType } from 'types/customer';

export type TaxformCustomerInfoType = CustomerInfoType;

export interface W8benProps {
    $formutil: $Formutil<{
        temporary_w8_confirm_signature: boolean;
    }>;
    customerInfo: TaxformCustomerInfoType;
    className?: string;
    disabled?: boolean;
    useHomeAddress?: boolean;
}

export interface W8benState {
    countryCode: CountryItem;
    taxCountry: CountryItem;
    legalResidenceCountry: CountryItem;
    deliveryCountry: CountryItem;
}
